var App = App || {};

const cookiePrefix = "MainstreetCU_Alert";
const cookieValueDismissed = "dismissed";
const cookieValueCollapsible = "collapsable";
const cookieValueCollapsed = "collapsed";

App.Alerts = (function () {
    'use strict';

    /* =========================================================================
    Initialization
    ========================================================================= */

    // Initializes all alert elements within the specified container selector.
    function initializeAlerts(alertsContainerId) {

        const alertsContainerElement = document.getElementById(alertsContainerId);
        if (!alertsContainerElement) return;

        const alertElementList = alertsContainerElement.querySelectorAll(".alert");
        if (alertElementList.length === 0) return;

        for (const alertElement of alertElementList) {
            bindDismissEvent(alertElement);
            bindCollapseButtonEvent(alertElement);
        }
    }

    /* =========================================================================
    Event Binding
    ========================================================================= */

    // Binds the dismiss event to the alert element and sets a cookie when dismissed.
    const bindDismissEvent = (alertElement) => {
        alertElement.addEventListener("closed.bs.alert", function () {
            setAlertCookie(alertElement, cookieValueDismissed);
        });
    };

    // Binds the collapse button event to the alert element if the button exists.
    const bindCollapseButtonEvent = (alertElement) => {
        const collapseButton = alertElement.querySelector(".btn-collapse");
        if (!collapseButton) return;

        collapseButton.addEventListener("click", () => {
            toggleCollapsibleAlert(alertElement, collapseButton);
        });
    };

    /* =========================================================================
    UI Synchronization
    ========================================================================= */

    // Toggles the collapsed state of the alert and updates the corresponding cookie.
    const toggleCollapsibleAlert = (alertElement, collapseButton) => {
        if (collapseButton.getAttribute("aria-expanded") == "false") {
            collapseButton.setAttribute("aria-expanded", "true");
            alertElement.classList.remove("collapsed")
            alertElement.setAttribute("role", "alert");
            setAlertCookie(alertElement, cookieValueCollapsible);
        }
        else {
            collapseButton.setAttribute("aria-expanded", "false");
            alertElement.classList.add("collapsed")
            alertElement.setAttribute("role", null);
            setAlertCookie(alertElement, cookieValueCollapsed);
        }
    };

    /* =========================================================================
    Helpers
    ========================================================================= */

    // Sets a cookie for the alert element to persist its state using a unique identifier.
    const setAlertCookie = (alertElement, cookieValue) => {
        const alertGuid = alertElement.dataset.guid;
        if (!alertGuid) return;
        const cookieName = `${cookiePrefix}_${alertGuid}`;
        App.Cookies.setCookie(cookieName, cookieValue, Infinity, "/", window.location.hostname, window.location.protocol === "https:");
    };

    /* =========================================================================
    Public API Exposure
    ========================================================================= */

    return {
        initializeAlerts
    };

})();